// extracted by mini-css-extract-plugin
export var blue = "_3f-f";
export var brand = "_3f-b";
export var darkGrey = "_3f-e";
export var disabled = "_3f-4";
export var disabledSubtle = "_3f-5";
export var error = "_3f-6";
export var green = "_3f-g";
export var grey = "_3f-d";
export var icon = "_3f-0";
export var inherit = "_3f-a";
export var lightGrey = "_3f-c";
export var orange = "_3f-i";
export var pink = "_3f-k";
export var primary = "_3f-1";
export var purple = "_3f-l";
export var red = "_3f-j";
export var secondary = "_3f-2";
export var success = "_3f-9";
export var tertiary = "_3f-3";
export var warning = "_3f-7";
export var warningSecondary = "_3f-8";
export var white = "_3f-m";
export var yellow = "_3f-h";